import React, { useState, useEffect } from 'react'
import CheckBoxRadioButtonInput from '../forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'

import { SortIcon } from './SortIcon'
import { Header } from './types'

interface IProps {
  headers: Header[]
  rowClass?: string
  selector?: boolean
  withSelector?: boolean
  onChangeSelector?: (selector: boolean) => void
  handleSort?: (header: any[]) => void
}

const TableHeader: React.FC<IProps> = ({
  headers: originalHeaders,
  rowClass,
  selector,
  withSelector,
  onChangeSelector,
  handleSort,
}) => {
  const [headers, setHeaders] = useState([] as Header[])

  useEffect(() => {
    setHeaders(originalHeaders)
  }, [originalHeaders])

  const handleClick = (header: Header) => {
    switch (header.order) {
      case 'asc':
        header.order = 'desc'
        break
      case 'desc':
        header.order = ''
        break
      default:
        header.order = 'asc'
        break
    }

    setHeaders(
      headers.map((headerItem) =>
        headerItem.key === header.key ? header : headerItem
      )
    )

    handleSort?.(headers.filter(({ key, order }) => key && order))
  }

  const renderHeaders = headers.map((header, index) => {
    return (
      <th key={index} className={header.className} {...header.thProps}>
        {header.label}
        {header.key && (
          <SortIcon header={header} onClick={() => handleClick(header)} />
        )}
      </th>
    )
  })

  const renderSelector = (
    <th>
      <CheckBoxRadioButtonInput
        name={`check-all`}
        type="checkbox"
        onChange={(e: any) => onChangeSelector?.(e.target.checked)}
        checked={selector}
      />
    </th>
  )

  return (
    <tr className={rowClass}>
      {withSelector && renderSelector}
      {renderHeaders}
    </tr>
  )
}

export default TableHeader
